module.exports = __webpack_public_path__ + "static/img/how4.d4426ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/how4.png
// module id = cBo9
// module chunks = 1